import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { getOrder } from '../../../order'
import * as locations from '../../../../addressbook/locations'
import Button from '../../../../../ui/Button'
import ImmutablePropTypes from 'react-immutable-proptypes'
import styles from './css/LocationSearch.scss'

export class LocationSearch extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        order: ImmutablePropTypes.map.isRequired,
        isSearching: PropTypes.bool.isRequired,
        intl: PropTypes.object.isRequired,
    }

    constructor (props) {
        super(props)
        this.state = {
            searchTerm: '',
            searchTimeout: null,
        }
    }

    componentWillUnmount () {
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout)
        }
    }

    handleSearchChange = (e) => {
        const searchTerm = e.target.value
        this.setState({ searchTerm })

        // Clear previous timeout
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout)
        }

        // Set new timeout for fuzzy search
        const timeout = setTimeout(() => {
            if (searchTerm.trim()) {
                this.props.dispatch(locations.searchLocationsByNumber(searchTerm))
            } else {
                // Clear search results when input is empty
                this.props.dispatch(locations.clearSearchResults())
            }
        }, 300) // 300ms delay for fuzzy search

        this.setState({ searchTimeout: timeout })
    }

    handleClearSearch = () => {
        this.setState({
            searchTerm: ''
        })
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout)
        }

        this.props.dispatch(locations.clearSearchResults())
    }

    render () {
        const { searchTerm } = this.state
        const { isSearching, intl } = this.props
        const hasSearchTerm = searchTerm.trim().length > 0

        return (
            <div className={styles.container}>
                <input
                    type="text"
                    value={searchTerm}
                    onChange={this.handleSearchChange}
                    placeholder={intl.formatMessage({ id: 'frontend.form_selector_shipping.placeholder.search_placeholder' })}
                    className={styles.input}
                />

                {hasSearchTerm && (
                    <Button
                        emphasis="secondary"
                        onClick={this.handleClearSearch}
                    >
                        <FormattedMessage id="frontend.form_selector_shipping.button.clear_search"/>
                    </Button>
                )}
                {isSearching && (
                    <span style={{ fontSize: '14px', color: '#666' }}>
                        <FormattedMessage id="frontend.form_selector_shipping.text.searching"/>
                    </span>
                )}
            </div>
        )
    }
}

export default connect(state => ({
    order: getOrder(state),
    isSearching: locations.selectIsSearching(state),
}))(injectIntl(LocationSearch))
